import { simpleSet } from '@r/reducers/utils';

const setOrthoMode = simpleSet as redux.reducers.floorPlanTools.orthoMode;
export const orthoMode = setOrthoMode(
  'SET_ORTHO_MODE',
  true
);
